import React from 'react'
import styled from 'styled-components'
import { applyProps, PropTypesStyledHTML } from '../../../../utils/styled_helpers'

// Interface para as props que serão passadas para o styled-component
interface StyledFlexProps extends Omit<PropTypesStyledHTML, 'flexWrap' | 'flexDir' | 'alignContent' | 'justifyItems' | 'justifyContent'> {
  $flexWrap?: any;
  $flexDir?: any;
  $alignContent?: any;
  $justifyItems?: any;
  $justifyContent?: any;
}

// Interface para as props do componente React
interface FlexProps extends PropTypesStyledHTML {
  flexWrap?: any;
  flexDir?: any;
  alignContent?: any;
  justifyItems?: any;
  justifyContent?: any;
}

const FlexStyled = styled.div<StyledFlexProps>`
  display: flex;
  flex-wrap: ${props => props.$flexWrap};
  flex-direction: ${props => props.$flexDir};
  align-content: ${props => props.$alignContent};
  justify-items: ${props => props.$justifyItems};
  justify-content: ${props => props.$justifyContent};
  ${(props) => applyProps(props)}
`

export const Flex: React.FC<FlexProps> = ({
  flexWrap,
  flexDir,
  alignContent,
  justifyItems,
  justifyContent,
  children,
  ...rest
}) => (
  <FlexStyled
    $flexWrap={flexWrap}
    $flexDir={flexDir}
    $alignContent={alignContent}
    $justifyItems={justifyItems}
    $justifyContent={justifyContent}
    {...rest}
  >
    {children}
  </FlexStyled>
)
